import { Component, OnInit } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { PopupMessageModalComponent } from '../modals/popup-message-modal/popup-message-modal.component'

import { SiteService } from '../../services/site.service'
import { MessageService } from '../../services/message.service'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public translateService: TranslateService,
    private siteService: SiteService,
    private messageService: MessageService
  ) 
  { 
  }

  ngOnInit() 
  {
  }

  // startChat()
  // {
  //   this.messageService.startedHttpRequest('startChat')
	// 	this.siteService
	// 		.getChatAvailability()
	// 		.toPromise()
	// 		.then((apiResponse) =>
	// 		{
	// 			this.messageService.completedHttpRequest('startChat')

	// 			if (apiResponse)
	// 			{
	// 				// @ts-ignore
  //         window.customPlugin.command('WebChat.open',configureChat(this.translateService.currentLang,'','','','',''))
	// 			}
	// 			else
	// 			{
  //         const dialogConfig = new MatDialogConfig()
  //         dialogConfig.width = '500px',
  //         dialogConfig.data = {
  //           title: this.translateService.instant('POPUP_CHAT_UNAVAILABLE_TITLE'),
  //           message: this.translateService.instant('POPUP_CHAT_UNAVAILABLE_BODY'),
  //         }

  //         this.dialog.open(PopupMessageModalComponent, dialogConfig)
	// 			}
	// 		})
	// 		.catch((e) =>
	// 		{
	// 			this.messageService.completedHttpRequest('startChat')
	// 		})
  // }
}
